import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { getBusinessPartnerModel } from "../../BusinessPartner/Infrastructure/BusinessPartner.reducer";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import MicNoneIcon from "@mui/icons-material/MicNone";
import FormControl from "@mui/material/FormControl";
import { TextField } from "@mui/material";
import FlatButton from "../../DesignSystem/FlatButton";
import ButtonText from "../../DesignSystem/ButtonText";
import FlatBlueButton from "../../DesignSystem/FlatBlueButton";
import Divider from "@mui/material/Divider";
import DeliveryManCard from "../../DesignSystem/DeliveryManCard";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import AdviserCard from "../../DesignSystem/AdviserCard";
import RegisterModal from "../../DesignSystem/RegisterModal";
import RegisterForm from "./RegisterForm";
import ModalAlert from "../../DesignSystem/ModalAlert";
import { GetAdviserList, GetAdviserListBySearchBar } from "../../Adviser/Infrastructure/Adviser.presenter";
import { GetDeliveryList, GetDeliveryListBySearchBar } from "../../Delivery/Infrastructure/Delivery.presenter";
import RadioOrderGroup from "../../DesignSystem/RadioOrderGroup";

const boxContainerStyles = {
  background: "white",
  width: { xs: "100%", sm: "100%", md: "90%" },
  height: "auto",
  maxWidth: "1110px",
  margin: { sm: "0px", md: "auto" },
  minHeight: "913px",
  padding: { xs: "60px 5px", sm: "40px 20px", md: "36px 40px 59px" },
};

const searchFormControl = {
  display: "flex",
  justifyContent: "center",
  gap: "10px",
  alignItems: { xs: "center", md: "baseline" },
  flexDirection: { xs: "column", md: "row" },
};

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 20,
    [theme.breakpoints.down("lg")]: {
      alignItems: "center",
      flexDirection: "row",
      display: "flex",
    },
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  title: {
    lineHeight: "58.09px",
    fontSize: "3rem",
    color: "#333333",
  },
  searchContainer: {
    padding: "20px 0px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
    [theme.breakpoints.down("lg")]: {
      alignItems: "stretch",
      flexDirection: "column",
    },
  },
  inputStyles: {
    border: "1px solid #E0E0E0",
    borderRadius: 10,
    height: 35,
    padding: "0px 10px",
    fontWeight: 500,
  },
  userContainer: {
    marginTop: 20,
    [theme.breakpoints.up("md")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "20px 60px",
      justifyItems: "center",
    },
  },
  order: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("lg")]: {
      justifyContent: "flex-start",
    },
    [theme.breakpoints.down("md")]: {
      justifyContent: "space-between",
    },
  },
  buttons: {
    display: "flex",
    justifyContent: "space-between",
  },
  buttonAdd: {
    [theme.breakpoints.up("md")]: {
      width: 213,
    },
  },
}));

export default function UsersChatList({ role }) {
  const history = useHistory();
  const classes = useStyles();
  const businessPartner = useSelector(getBusinessPartnerModel);
  const [advisers, setAdvisers] = useState([]);
  const [dealers, setDealers] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isOpenFormModal, setFormModal] = useState(false);
  const [adviserR, setAdviserR] = useState(false);
  const [deliveryR, setDeliveryR] = useState(false);
  const [order, setOrder] = useState("Orden alfabético a-z");
  const [show, setShow] = useState(false);
  const elementRef = useRef();
  const [isOpenAlert, setOpenAlert] = useState(false);
  const [titleAlert, setTitleAlert] = useState("Ha ocurrido un error");
  const showAlertModal = () => setOpenAlert(true);

  const handleClickOpen = (alertState) => {
    setOpenAlert(alertState);
  };

  const getSortType = (value) => {
    setOrder(value !== undefined ? value : "Orden alfabético a-z");
    if (value === "Orden alfabético z-a") {
      setAdvisers(advisers.reverse());
      setDealers(dealers.reverse());
    } else if (value === "Fecha de contratación") {
      setAdvisers(advisers.sort(dateSort));
      setDealers(dealers.sort(dateSort));
    } else {
      setAdvisers(advisers.sort(SortArrayAZ));
      setDealers(dealers.sort(SortArrayAZ));
    }
  };

  function dateSort(a, b) {
    return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
  }

  function SortArrayAZ(x, y) {
    if (x.name < y.name) {
      return -1;
    }
    if (x.name > y.name) {
      return 1;
    }
    return 0;
  }

  const [breakpoint, setBreakpoint] = React.useState(
    window.innerWidth <= 768 ? true : false
  );

  const title = () => (role === "delivery" ? "REPARTIDORES" : "ASESORES");
  const btnText = () =>
    role === "delivery" ? "Agregar repartidor" : "Agregar asesor";
  const placeholderText = () =>
    role === "delivery" ? "Buscar repartidor" : "Buscar asesor";

  const handleResizeTitle = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 768) {
      setBreakpoint(true);
    } else if (screenWidth >= 769) {
      setBreakpoint(false);
    }
  };

  //obtener el estado del formModal
  const handleFormModal = (formModalState) => {
    setFormModal(formModalState);
  };

  const handleListChange = (isChange) => {
    setFormModal(false);
    if (isChange && role === "delivery") {
      fetchDataDelivery(businessPartner.zone);
    } else if (isChange && role === "adviser") {
      fetchDataAdviser(businessPartner.zone);
    }
  };

  useEffect(function () {
    const onChange = (entries, observer) => {
      const el = entries[0];
      if (el.isIntersecting) {
        setShow(true);
        observer.disconnect();
      }
    };
    const observer = new IntersectionObserver(onChange, {
      rootMargin: "100px",
    });
    observer.observe(elementRef.current);
    return () => observer.disconnect();
  });

  useEffect(() => {
    if (businessPartner) {
      fetchDataAdviser(businessPartner.zone);
      fetchDataDelivery(businessPartner.zone);
    }
    window.addEventListener("resize", handleResizeTitle);
    window.addEventListener("load", handleResizeTitle);
    return () => {
      window.removeEventListener("resize", handleResizeTitle);
      window.addEventListener("load", handleResizeTitle);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessPartner]);

  async function fetchDataAdviser(zone) {
    try {
      //setLoading(true);
      const info = await GetAdviserList(zone);
      //setLoading(false);
      setAdvisers(info.sort(SortArrayAZ));
      setAdviserR(true);
    } catch (error) {
      console.log("error", error);
    }
  }

  async function fetchDataDelivery(zone) {
    try {
      //setLoading(true);
      const info = await GetDeliveryList(zone);
      console.log("delivery",info)
      //setLoading(false);
      setDealers(info.sort(SortArrayAZ));
      setDeliveryR(true);
    } catch (error) {
      console.log("error");
    }
  }

  const handleChangeInputSearch = (e) => {
    setSearchValue(e.target.value);
  };

  const handleSubmitAdviserSearch = async () => {
    try{
      const info = await GetAdviserListBySearchBar(
        businessPartner.zone,
        searchValue
      );
      if(info.length !== 0){
        setAdvisers(info);
      }else{
        setTitleAlert("Sin resultados");
        showAlertModal();
      }
      setSearchValue("");
    }catch(error){
      console.log("Ocurrió un error: ", error);
      setSearchValue("");
    }
  };

  const handleSubmitDeliverySearch = async () => {
    try{
      const info = await GetDeliveryListBySearchBar(
        businessPartner.zone,
        searchValue
      );
      if(info.length !== 0){
        setDealers(info);
      }else{
        setTitleAlert("Sin resultados");
        showAlertModal();
      }
      setSearchValue("");
    }catch(error){
      console.log("Ocurrió un error: ", error);
      setSearchValue("");
    }
  };

  return (
    <Box sx={boxContainerStyles}>
      {breakpoint === false ? (
        <>
          <div className={classes.headerContainer}>
            <h3 className={classes.title}>{title()}</h3>
            <div className={classes.buttonAdd}>
              <FlatButton
                title={btnText()}
                typeButton="button"
                widthBtn="100%"
                icon={<AddBoxOutlinedIcon />}
                onClick={() => setFormModal(true)}
              />
            </div>
          </div>
          <Divider sx={{ marginTop: "20px" }} />
          <div className={classes.searchContainer}>
            <RadioOrderGroup typeOrder={order} handleValue={getSortType} />
            <FormControl sx={searchFormControl}>
              <TextField
                fullWidth
                type="text"
                variant="standard"
                placeholder={placeholderText()}
                onChange={handleChangeInputSearch}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    role === "delivery"
                      ? handleSubmitDeliverySearch()
                      : handleSubmitAdviserSearch();
                  }
                }}
                id="busqueda"
                value={searchValue}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#333333" }} />
                    </InputAdornment>
                  ),
                  disableUnderline: true,
                  classes: { root: classes.inputStyles },
                  sx: { fontSize: ".9rem" },
                }}
              />
              <ButtonText
                title="Buscar"
                typeButton="button"
                onClick={
                  role === "delivery"
                    ? handleSubmitDeliverySearch
                    : handleSubmitAdviserSearch
                }
                widthBtn="100px"
              />
            </FormControl>
          </div>
        </>
      ) : (
        <>
          <div className={classes.headerContainer}>
            <div>
              <FormControl sx={searchFormControl}>
                <TextField
                  fullWidth
                  variant="standard"
                  type="text"
                  placeholder={placeholderText()}
                  onChange={handleChangeInputSearch}
                  value={searchValue}
                  id="busqueda"
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      role === "delivery"
                        ? handleSubmitDeliverySearch()
                        : handleSubmitAdviserSearch();
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: "#333333" }} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <MicNoneIcon sx={{ color: "#004990" }} />
                      </InputAdornment>
                    ),
                    disableUnderline: true,
                    classes: { root: classes.inputStyles },
                    sx: { fontSize: ".9rem" },
                  }}
                />
              </FormControl>
            </div>
            <div className={classes.buttons}>
              <FlatBlueButton
                title="Repartidores"
                typeButton="button"
                widthBtn="160px"
                isDisabled={role === "adviser"}
                onClick={() => history.push("/personal/repartidores")}
              />
              <FlatBlueButton
                title="Asesores"
                typeButton="button"
                widthBtn="160px"
                isDisabled={role === "delivery"}
                onClick={() => history.push("/personal/asesores")}
              />
            </div>
            <div className={classes.buttonAdd}>
              <FlatButton
                title={btnText()}
                typeButton="button"
                widthBtn="100%"
                onClick={() => history.push(`/register/${role}`)}
                icon={<AddBoxOutlinedIcon />}
              />
            </div>
            <RadioOrderGroup
              typeOrder={"Orden alfabético a-z"}
              handleValue={getSortType}
            />
          </div>
        </>
      )}
      <div ref={elementRef} className={classes.userContainer}>
        {show ? (
          role === "delivery" && deliveryR ? (
            dealers.length !== 0 ? (
              <>
                {dealers.map((delivery) => (
                  <DeliveryManCard
                    key={delivery.id}
                    id={delivery.id}
                    name={delivery.name}
                    lastName={delivery.last_name}
                    image={delivery.url_photoProfile}
                    matricula="00-00-00"
                    handleDeletedUser={handleListChange}
                  />
                ))}
              </>
            ) : (
              <p style={{ width: "-webkit-fill-available" }}>Sin resultados</p>
            )
          ) : (
            <></>
          )
        ) : null}

        {show ? (
          role === "adviser" && adviserR ? (
            advisers.length !== 0 ? (
              <>
                {advisers.map((adviser) => (
                  <AdviserCard
                    key={adviser.id}
                    id={adviser.id}
                    name={adviser.name}
                    lastName={adviser.last_name}
                    image={adviser.url_photoProfile}
                    handleDeletedUser={handleListChange}
                  />
                ))}
              </>
            ) : (
              <p style={{ width: "-webkit-fill-available" }}>Sin resultados</p>
            )
          ) : (
            <></>
          )
        ) : null}
      </div>
      <RegisterModal isOpen={isOpenFormModal} handleModal={handleFormModal}>
        <RegisterForm role={role} handleAddUser={handleListChange}/>
      </RegisterModal>
      <ModalAlert
        title={titleAlert}
        typeAlert={"error"}
        isOpen={isOpenAlert}
        handleAlert={handleClickOpen}
      />
    </Box>
  );
}